import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 7 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 7 9\" id=\"icon-delete\"><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M4.5 1.25v-.5h-2v.5H0v1h.7l.276 5.525a.5.5 0 0 0 .5.475h4.048a.5.5 0 0 0 .5-.475L6.3 2.25H7v-1zm-2.5 5v-3h1v3zm2 0v-3h1v3z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol